<template>
  <div class="pullCard">
    <h2>{{cardDetail.activityName}}</h2>
    <h3>参与时间：{{cardDetail.participationTime}}</h3>
    <div class="progressConter">
      <div class="progress">
        <div :class="['progressUi',cardDetail.activityStatus===2?'progressActive':cardDetail.activityStatus===3?'progressDefault':'']" :style="{ width: progressWidth + '%' }">
          <div class="circular"></div>
        </div>
      </div>
      <div class="progressnNum">{{cardDetail.shareNumber>cardDetail.limitNumber?cardDetail.limitNumber:cardDetail.shareNumber}}/{{cardDetail.limitNumber}}</div>
    </div>
    <template v-if="cardDetail.activityStatus===2">
      <div class="countTime">
        <div class="countText">倒计时：</div>
        <div class="remaining">
          <span>{{times.d}}</span>
          <b>天</b>
          <span>{{times.h}}&nbsp;:</span>
          <span>{{times.m}}&nbsp;:</span>
          <span>{{times.s}}</span>
        </div>
      </div>
    </template>
    <div v-if="cardDetail.activityStatus===3" class="theEnd">已结束</div>

  </div>
</template>
<script>
import { timerCount, replaceHyphens } from '@/utils/tools';

export default {
  components: { },
  props: {
    cardDetail: {
      type: Object,
      default: () => ({}),
    },
    nowTime: {
      type: String,
    },
  },
  data() {
    return {
      endTime: null,
      times: '',
      timers: null,
      progressWidth: 0,
      currentTime: new Date().getTime(),
    };
  },
  computed: {

  },
  watch: {

  },
  created() { },
  mounted() {
    // 进度条
    const actualNum = this.cardDetail.shareNumber > this.cardDetail.limitNumber ? this.cardDetail.limitNumber : this.cardDetail.shareNumber;
    this.progressWidth = (actualNum / this.cardDetail.limitNumber).toFixed(2) * 100;
    this.currentTime = new Date(replaceHyphens(this.nowTime)).getTime();
    if (this.cardDetail.activityStatus === 2) {
      this.init();
    }
  },
  destroyed() { clearInterval(this.timers); },
  methods: {

    init() {
      this.endTime = new Date(replaceHyphens(this.cardDetail.endTime)).getTime();
      let temp = this.endTime - this.currentTime + 1000;
      this.times = timerCount(temp, 2);
      this.timers = setInterval(() => {
        temp -= 1000;
        if (temp > 0) {
          this.times = timerCount(temp, 2);
        } else {
          // 倒计时结束  重新拉取接口请求
          clearInterval(this.timers);
        }
      }, 1000);
    },

  },
};
</script>
<style scoped lang="scss">
.pullCard{
  box-sizing: border-box;
  width: 100%;
  padding:22px 36px;
  background: #fff;
  border-radius: 14px;
  h2{
    overflow: hidden;
    color: #333;
    font-weight: 500;
   font-size: 33px;
    line-height: 45px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  h3{
    padding:18px 0 34px 0;
    color: #787878;
    font-weight: 400;
    font-size: 25px;
    line-height: 36px;
  }
  .progressConter{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 31px;
    border-bottom: 2px solid #F5F5F5;
    .progress{
      position: relative;
      width: 500px;
      height: 25px;
      background: #F5F5F5;
      border-radius: 18px;
      .progressUi{
        position: absolute;
        top: 0;
        left: 0;
        width: 20%;
        height: 100%;
        border-radius: 18px;
        .circular{
          float: right;
          width: 11px;
          height: 11px;
          margin-top:7px;
          margin-right: 7px;
          background: #fff;
          border-radius: 50%;
        }

      }
      .progressActive{
         background: #ff6c02;
      }
      .progressDefault{
         background: #FFD7BB !important;
      }

    }
    .progressnNum{
      color: #787878;
      font-weight: 400;
      font-size: 25px;
      line-height: 25px;
    }

  }
  .countTime{
    display: flex;
    margin-top:25px;
    .countText{
      color: #787878;
      font-weight: 400;
      font-size: 25px;
      line-height: 36px;
    }
    .remaining{
      display: flex;
      span{
        display: block;
        margin-left:5px;
        color: #FF6C02;
        font-weight: 600;
        font-size: 25px;
        line-height: 36px;

      }
      b{
         display: block;
        margin-left:5px;
        color: #787878;
        font-weight: 400;
        font-weight: normal;
        font-size: 25px;
        line-height: 36px;

      }
    }

  }
  .theEnd{
    margin-top: 25px;
    color: #787878;
    font-weight: 400;
    font-size: 25px;
    line-height: 36px;
  }

}

</style>
